export default __webpack_public_path__ + "static/media/GreyContact.9deb60c3.svg";